import React from 'react';
import { RouteComponentProps } from 'react-router';

import Page from './Page';

import { getProperty } from '../lib/api/property';
import { populate as populateProperty } from '../../shared/lib/property';
import { getSETPlanTemplates, populate } from '../lib/api/plan';
import { Property } from '../../shared/types/property';
import { Plan } from '../../shared/types/plan';

import './PlanLibrary.scss';
import { getBrand } from '../lib/api/brand';
import { LibraryHeader, DataTable } from '@spark-labs/avocado-ui';
import { LoadingIndicator } from '@spark-labs/avocado-ui/dist/components/LoadingIndicator';

export interface PlanLibraryProps {
  propertyId: string;
}

export interface PlanLibraryState {
  property?: Property;
  planTemplates: Plan[];
}

export interface PlanLibraryParams {
  property: string;
}

type PlanLibraryPageProps = PlanLibraryProps & RouteComponentProps<PlanLibraryParams>;

const COLUMNS = ['Name', 'Num. Days', 'Num. Events'];
const COLUMN_WIDTHS = [70, 15, 15];

/**
 * Given an plan template, return a list of strings to show in the DataTable
 *
 */
function planTemplateToRow(pt: Plan) {
  return [pt.name, String(1), String(pt.events.length)];
}

export default class PlanLibrary extends React.Component<PlanLibraryPageProps, PlanLibraryState> {
  public readonly state: PlanLibraryState = { planTemplates: [] };
  private propertyId: string;

  constructor(props: PlanLibraryPageProps) {
    super(props);
    this.propertyId = props.match.params.property;
  }

  public async componentDidMount() {
    let [bareProperty, barePlanTemplates] = await Promise.all([
      getProperty(this.propertyId),
      getSETPlanTemplates(this.propertyId),
    ]);

    let brand = await getBrand(bareProperty.brand);
    let property = populateProperty(bareProperty, brand);

    this.setState({
      property,
      planTemplates: barePlanTemplates.map(v => populate(v, property)),
    });
  }

  public render() {
    return (
      <Page className="PlanLibrary absolute flex items-stretch">
        <div className="SideMenu bg-blue-darkest flex flex-col">
          <div className="bg-white flex flex-col items-center pb-4">
            {this.state.property && <img src={this.state.property.brand.logo} />}
            <a href="#">
              <LibraryHeader size="sm">
                {this.state.property && this.state.property.brand ? (
                  this.state.property.brand.name
                ) : (
                  <LoadingIndicator size="small" className="mt-6" />
                )}
              </LibraryHeader>
            </a>
          </div>
          <div className="bg-blue-darker flex flex-col items-center py-4" />
        </div>
        <div className="LibraryBody flex-grow bg-blue-lightest flex flex-col">
          <div className="LibraryHeader mt-8 ml-16">
            <LibraryHeader>Daily Plan Library</LibraryHeader>
          </div>

          <div className="LibraryTable mx-10 flex-grow overflow-auto">
            <DataTable<Plan>
              elements={this.state.planTemplates}
              columnTitles={COLUMNS}
              rowFunction={planTemplateToRow}
              columnWidths={COLUMN_WIDTHS}
            />
          </div>
        </div>
      </Page>
    );
  }
}
